export default [
  {
    id: 'PREVIEW_DEVICE_GOOGLE_PIXEL_2',
    label: 'Google Pixel 2',
    width: 1080,
    height: 1920,
    pixelRatio: 2.6
  },
  {
    id: 'PREVIEW_DEVICE_GOOGLE_PIXEL_2XL',
    label: 'Google Pixel 2 XL',
    width: 1440,
    height: 2880,
    pixelRatio: 3.5
  },
  {
    id: 'PREVIEW_DEVICE_SAMSUNG_GALAXY_S5',
    label: 'Samsung Galaxy S5',
    width: 1080,
    height: 1920,
    pixelRatio: 3
  },
  {
    id: 'PREVIEW_DEVICE_SAMSUNG_GALAXY_S7',
    label: 'Samsung Galaxy S7',
    width: 1440,
    height: 2560,
    pixelRatio: 4
  },
  {
    id: 'PREVIEW_DEVICE_SAMSUNG_GALAXY_S9',
    label: 'Samsung Galaxy S9',
    width: 1440,
    height: 2960,
    pixelRatio: 3.7
  },
  {
    id: 'PREVIEW_DEVICE_APPLE_IPHONE_5',
    label: 'Apple iPhone 5/SE',
    width: 640,
    height: 1136,
    pixelRatio: 2
  },
  {
    id: 'PREVIEW_DEVICE_APPLE_IPHONE_7',
    label: 'Apple iPhone 6/7/8',
    width: 750,
    height: 1334,
    pixelRatio: 2
  },
  {
    id: 'PREVIEW_DEVICE_APPLE_IPHONE_7_PLUS',
    label: 'Apple iPhone 6/7/8 Plus',
    width: 1080,
    height: 1920,
    pixelRatio: 2.5
  },
  {
    id: 'PREVIEW_DEVICE_APPLE_IPHONE_X',
    label: 'Apple iPhone X',
    width: 1125,
    height: 2436,
    pixelRatio: 3
  },
  {
    id: 'PREVIEW_DEVICE_APPLE_IPAD',
    label: 'Apple iPad',
    width: 768,
    height: 1024,
    pixelRatio: 1
  },
  {
    id: 'PREVIEW_DEVICE_APPLE_IPAD_PRO',
    label: 'Apple iPad',
    width: 2048,
    height: 2732,
    pixelRatio: 2
  }
]
